import React, { useEffect } from 'react';
import {
    getAllTrailsList,
    getTrailGeoJson2Combine,
    initiateActiveCollectionPreview,
    initiateCombine,
    removeTrailFromCombine,
} from '../../store/adminActions';
import { trails2combine } from '../../store/adminSelector';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

function CollectionsCombiner(props) {
    const {
        initAllTrailsList,
        trailsList,
        getTrailGeoJson2Combine,
        trails2combine,
        removeTrailFromCombine,
        initiateCombine,
    } = props;
    // trals list load
    useEffect(() => {
        if (!trailsList.length) {
            initAllTrailsList();
        }
    }, [trailsList, initAllTrailsList]);
    const onSelectTrail = (e) => {
        getTrailGeoJson2Combine(e.target.value);
    };
    if (!trailsList || !trailsList.length) {
        return <FormattedMessage id="admin.loadingTrails" />;
    }
    return (
        <div>
            <ol>
                {trails2combine.map((trail) => {
                    const { trailUUID, trailName, lines, points } = trail;
                    return (
                        <li key={trailUUID}>
                            {`${trailName} (${lines} + ${points})`}
                            <button
                                onClick={() =>
                                    removeTrailFromCombine(trailUUID)
                                }
                            >
                                -
                            </button>
                        </li>
                    );
                })}
            </ol>
            <div>
                <select onChange={onSelectTrail}>
                    {trailsList.map((trail, idx) => {
                        const { trailUUID, name } = trail;
                        return (
                            <option key={idx} value={trailUUID}>
                                {`${trailUUID} - ${name}`}
                            </option>
                        );
                    })}
                </select>
                <button
                    onClick={initiateCombine}
                    className={classNames({
                        inactive: trails2combine.length < 2,
                    })}
                >
                    <span>Combine</span>
                </button>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        trailsList: state.adminState.trailsList,
        trails2combine: trails2combine(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getTrailGeoJson2Combine: (uuid) =>
            dispatch(getTrailGeoJson2Combine(uuid)),
        removeTrailFromCombine: (uuid) =>
            dispatch(removeTrailFromCombine(uuid)),
        initiateCombine: () => {
            dispatch(initiateCombine());
            dispatch(initiateActiveCollectionPreview(true));
        },
        initAllTrailsList: () => dispatch(getAllTrailsList()),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CollectionsCombiner);
